const prefix = 'NOTIFICATION_MENU'; // Better be unique!!!
const getInitialState = () => ({
  open: false,
});

const getNewState = (state, action) => {
  if (state === undefined) { state = getInitialState(); }
  if (!action) { return state; }
  switch (action.type.replace(`${prefix}_#_`, '')) {
    case 'SET_OPEN':
      return {
        open: action.open,
      };
    case 'SIGN_IN_REQUEST':
      return {
        open: false,
      };
    default:
      return state;
  }
};

export default getNewState;
export { prefix };
